'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = require('react-bootstrap/lib/FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _HelpBlock = require('react-bootstrap/lib/HelpBlock');

var _HelpBlock2 = _interopRequireDefault(_HelpBlock);

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Label = require('./Label');

var _Label2 = _interopRequireDefault(_Label);

require('./_inputWrapper.scss');

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputWrapper = function InputWrapper(_ref) {
  var addOnPosition = _ref.addOnPosition,
      children = _ref.children,
      className = _ref.className,
      displayLabel = _ref.displayLabel,
      formControl = _ref.formControl,
      helpBlockMessage = _ref.helpBlockMessage,
      htmlId = _ref.htmlId,
      label = _ref.label,
      required = _ref.required,
      validationState = _ref.validationState;

  // Pass validation class to the child button so that it reflects the TextInput's validation state.
  var child = function child() {
    var buttonStyle = validationState === 'warning' ? 'warning' : validationState === 'error' ? 'danger' : 'default';

    var childComponent = children.type;
    if (childComponent === _Button2.default || childComponent === _DropdownButton2.default) {
      return _react2.default.createElement(
        _InputGroup2.default.Button,
        null,
        _react2.default.cloneElement(children, {
          bsStyle: buttonStyle
        })
      );
    } else if (childComponent === _InputGroup2.default.Button) {
      var button = children.props.children;
      return _react2.default.createElement(
        _InputGroup2.default.Button,
        null,
        _react2.default.cloneElement(button, {
          bsStyle: buttonStyle
        })
      );
    } else if (childComponent === _InputGroup2.default.Addon) {
      return children;
    } else {
      return _react2.default.createElement(
        _InputGroup2.default.Addon,
        { className: 'input-wrapper-addon' },
        children
      );
    }
  };

  return _react2.default.createElement(
    _FormGroup2.default,
    {
      controlId: htmlId,
      className: 'input-wrapper ' + className + '__formGroup',
      validationState: validationState
    },
    displayLabel && _react2.default.createElement(
      _Label2.default,
      {
        className: className,
        htmlId: htmlId + '-label',
        required: required
      },
      label
    ),
    children ? _react2.default.createElement(
      _InputGroup2.default,
      null,
      addOnPosition === 'prepend' && child(),
      formControl,
      addOnPosition === 'append' && child()
    ) : formControl,
    validationState && _react2.default.createElement(
      _HelpBlock2.default,
      null,
      helpBlockMessage
    )
  );
};

InputWrapper.propTypes = {
  addOnPosition: _propTypes2.default.oneOf(['append', 'prepend']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  displayLabel: _propTypes2.default.bool,
  formControl: _propTypes2.default.node,
  helpBlockMessage: _propTypes2.default.string,
  htmlId: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  validationState: _propTypes2.default.string
};

InputWrapper.defaultProps = {
  addOnPosition: 'append'
};

exports.default = InputWrapper;


//////////////////
// WEBPACK FOOTER
// ../fusion-ui-components/lib/internal/InputWrapper.js
// module id = 358
// module chunks = 2